import {createContext} from 'react'
import {Vista} from './asignaicontablaInterface'

interface PartnerContextProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
  vistaData: Vista
  setVistaData: (value: Vista) => void
  edit: boolean
  setEdit: (value: boolean) => void
  reloadTable: boolean
  setReloadTable: (value: boolean) => void
  tabUnitRole: {
    companyId: string
  }
  setTabUnitRole: React.Dispatch<React.SetStateAction<{companyId: string}>>
}

const PartnerContext = createContext<PartnerContextProps>({
  searchTerm: '',
  setSearchTerm: (value) => {},
  vistaData: {_id: '', nombre: '', url: '', contenido: '', id_empresa: '', estado: true},
  setVistaData: (value) => {},
  edit: false,
  setEdit: (value) => {},
  reloadTable: false,
  setReloadTable: (value) => {},
  tabUnitRole: {companyId: ''},
  setTabUnitRole: (value) => {},
})

export {PartnerContext}
